import { Link } from "react-router-dom";

export default function ContactHero() {
  return (
    <section className="pt-28 md:pt-36 pb-10 md:pb-12 bg-[#FAF5EC]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <nav className="flex items-center gap-2 text-xs font-semibold text-ink-500 mb-6">
          <Link to="/" className="hover:text-brand-600 cursor-pointer">Home</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-ink-900">Contact</span>
        </nav>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-end">
          <div className="lg:col-span-8">
            <div className="text-xs uppercase tracking-[0.18em] text-brand-600 font-bold mb-3">
              Get in touch
            </div>
            <h1 className="font-display text-4xl md:text-6xl font-bold text-ink-900 leading-[1.05] tracking-tight">
              Tell us about your move.
            </h1>
          </div>
          <div className="lg:col-span-4">
            <p className="text-base text-ink-600 leading-relaxed">
              Drop us a line and we'll send you a flat-rate quote — usually within an hour during business hours. No call-center pressure, no upsells.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}